module.exports = __webpack_public_path__ + "img/header-weddingRingsFinishes.636fe8f.webp";